import estilos from "./BarraPresupuesto.module.css";

interface Props {
  gastadoUsd: string | number;
  presupuestoUsd: string | number;
  remanenteUsd: string | number;
}

// Presupuesto DERIVADO (M6, backend/app/budget.py::compute_spent_usd/
// compute_remaining_usd): SUM(usage_records.cost_usd) del proyecto, cubre
// tanto el CLI de Claude (casi siempre ~$0, suscripcion) como el gasto REAL
// de fal.ai. `<meter>` es el elemento semantico correcto para un valor
// escalar dentro de un rango conocido (min/max), con soporte de lector de
// pantalla nativo -- sin ARIA a mano.
export function BarraPresupuesto({
  gastadoUsd,
  presupuestoUsd,
  remanenteUsd,
}: Props): JSX.Element {
  const gastado = Number(gastadoUsd);
  const presupuesto = Number(presupuestoUsd);
  const remanente = Number(remanenteUsd);
  const maximo = presupuesto > 0 ? presupuesto : 1;
  const agotado = remanente <= 0;

  return (
    <div className={estilos.contenedor}>
      <div className={estilos.fila}>
        <label htmlFor="medidor-presupuesto">Presupuesto</label>
        <span className={estilos.valores}>
          US${gastado.toFixed(2)} de US${presupuesto.toFixed(2)}
        </span>
      </div>
      <meter
        id="medidor-presupuesto"
        className={estilos.medidor}
        min={0}
        max={maximo}
        value={Math.min(Math.max(gastado, 0), maximo)}
        low={maximo * 0.5}
        high={maximo * 0.85}
        optimum={0}
      />
      <p
        className={agotado ? estilos.avisoAgotado : estilos.remanente}
        role={agotado ? "status" : undefined}
      >
        {agotado ? "Presupuesto agotado" : `Quedan US$${remanente.toFixed(2)}`}
      </p>
    </div>
  );
}
